export default __webpack_public_path__ + "static/media/compass-1.b39b9b6a.png";